module.exports = __webpack_public_path__ + "portfolio-detail.svg?582e89bbab276c4569e8d2346ec29aff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio-detail.svg
// module id = 305
// module chunks = 2